<template>
  <div class="ed-tooltip" :class="classDirection">
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'Tooltip',
    props: {
      direction: String,
      event: {
        type: String,
        default: 'hover',
      },
      timeout: {
        type: String,
        default: '2',
      },
    },
    data() {
      return {
      };
    },
    computed: {
      classDirection() {
        if (this.direction === 'top') {
          return 'ed-tooltip--top';
        } else if (this.direction === 'right') {
          return 'ed-tooltip--right';
        } else if (this.direction === 'bottom') {
          return 'ed-tooltip--bottom';
        } else if (this.direction === 'left') {
          return 'ed-tooltip--left';
        }
        return null;
      },
    },
    methods: {
      setTooltipPosition() {
        const parent = this.$el.parentNode;
        let parentHeight;
        let parentWidth;
        if (!parent.offsetHeight || parent.offsetHeight === 0) {
          parentHeight = parent.parentNode.offsetHeight;
        } else {
          parentHeight = parent.offsetHeight;
        }
        if (!parent.offsetWidth || parent.offsetWidth === 0) {
          parentWidth = parent.parentNode.offsetWidth;
        } else {
          parentWidth = parent.offsetWidth;
        }
        if (this.direction === 'top') {
          this.$el.style.top = `${parent.getBoundingClientRect().top}px`;
          this.$el.style.left = `${parent.getBoundingClientRect().left + (parentWidth / 2)}px`;
        } else if (this.direction === 'right') {
          this.$el.style.top = `${parent.getBoundingClientRect().top + (parentHeight / 2)}px`;
          this.$el.style.left = `${parent.getBoundingClientRect().left + parentWidth + 10}px`;
        } else if (this.direction === 'bottom') {
          this.$el.style.top = `${parent.getBoundingClientRect().top + parentHeight + 10}px`;
          this.$el.style.left = `${parent.getBoundingClientRect().left + (parentWidth / 2)}px`;
        } else if (this.direction === 'left') {
          this.$el.style.top = `${parent.getBoundingClientRect().top + (parentHeight / 2)}px`;
          this.$el.style.left = `${parent.getBoundingClientRect().left}px`;
        }
      },
      tooltipMechanics() {
        let parent = this.$el.parentNode;
        if (!parent.offsetHeight || !parent.offsetWidth) {
          parent = this.$el.parentNode.parentNode;
        }
        if (this.event && this.event === 'hover') {
          parent.addEventListener('mouseover', () => {
            this.setTooltipPosition();
            this.$el.style.opacity = 1;
            this.$el.style.zIndex = 2000;
            setTimeout(() => {
              this.$el.style.opacity = 0;
            }, (this.timeout * 1000));
            setTimeout(() => {
              this.$el.style.zIndex = -1;
            }, (this.timeout * 1000) + 500);
          });
        } else if (this.event && this.event === 'click') {
          parent.addEventListener('click', () => {
            this.setTooltipPosition();
            this.$el.style.opacity = 1;
            this.$el.style.zIndex = 2000;
            setTimeout(() => {
              this.$el.style.opacity = 0;
            }, (this.timeout * 1000));
            setTimeout(() => {
              this.$el.style.zIndex = -1;
            }, (this.timeout * 1000) + 500);
          });
        }
      },
    },
    mounted() {
      this.tooltipMechanics();
    },
  };
</script>



// WEBPACK FOOTER //
// tooltip.vue?54768de5